import { AssetImage, Product } from "gql/generated";
import { getStockSignal } from "shared/merchCatalog";

const activeVariants = (product: Product) =>
  (product.merchMetadata?.variants ?? []).filter(
    (v): v is NonNullable<typeof v> & { _id: string } =>
      !!v?._id && v.isActive !== false,
  );

export const getCatalogProductSummary = (
  product: Product,
  cartVariantQuantities: Record<string, number>,
) => {
  const variants = activeVariants(product);
  const prices = variants.map(v => v.price);
  const lowestPrice = prices.length > 0 ? Math.min(...prices) : 0;
  const hasPriceRange = new Set(prices).size > 1;
  const remaining = variants.reduce(
    (sum, v) =>
      sum + Math.max(v.inventoryCount - (cartVariantQuantities[v._id] ?? 0), 0),
    0,
  );
  const isSoldOut = variants.length === 0 || remaining === 0;
  const quantityInCart = variants.reduce(
    (sum, v) => sum + (cartVariantQuantities[v._id] ?? 0),
    0,
  );
  const image = (product.images?.[0] ?? null) as Partial<AssetImage> | null;
  const stockSignal = getStockSignal(
    remaining,
    product.merchMetadata?.lowStockThreshold,
  );

  return {
    lowestPrice,
    hasPriceRange,
    isSoldOut,
    quantityInCart,
    image,
    remaining,
    stockSignal,
  };
};
